// extracted by mini-css-extract-plugin
export default {"companyName":"columns_companyName__DmcGa","statusDateText":"columns_statusDateText__XUw0r"};